import { useState, useEffect } from 'react';
import { partnerApi } from '@/services/api';
import { PARTNER_EMAIL, buildPartnerMailto } from '@/features/partner/constants';

const DEFAULTS = {
  contact_email: PARTNER_EMAIL,
  bli_partner: {},
  anslut: {},
};

export function usePartnerContent() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    partnerApi
      .getContent()
      .then((res) => {
        if (!cancelled) setSettings(res.data);
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err);
          setSettings(DEFAULTS);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, []);

  const email = settings?.contact_email || PARTNER_EMAIL;
  const mailto = buildPartnerMailto(email);

  return { settings, loading, error, contactEmail: email, mailto };
}
